import type Marker from './marker';

export default class TranscriptMarker implements Marker {
  p: number;

  constructor(position: number) {
    this.p = position;
  }
}
